import { lottoChanceData } from "./change";
import { extra6Data, extra7Data } from "./extra";
import { lottoTurboData } from "./turbo";

export const dataTableDoubleChange = [
    {
        title: 'LOTTO CHANGE',
        dataTable: [...lottoChanceData]
    },
    {
        title: 'LOTTO TURBO',
        dataTable: [...lottoTurboData]
    },
    {
        title: 'LOTTO EXTRA 6',
        dataTable: [...extra6Data]
    },
    {
        title: 'LOTTO EXTRA 7',
        dataTable: [...extra7Data]
    }
]
